/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="89.25"
        height="95.58"
        viewBox="0 0 89.25 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M45.32 77.84a8.87 8.87 0 1 0 8.87 8.87 8.87 8.87 0 0 0-8.87-8.87Zm0 2.5A6.37 6.37 0 1 1 39 86.71a6.37 6.37 0 0 1 6.32-6.37ZM78.09 53.35A11.16 11.16 0 1 0 89.24 64.5a11.15 11.15 0 0 0-11.15-11.15Zm0 2.5a8.66 8.66 0 1 1-8.66 8.65 8.66 8.66 0 0 1 8.66-8.65ZM10.4 53.21a10.4 10.4 0 1 0 10.39 10.4 10.39 10.39 0 0 0-10.39-10.4Zm0 2.5a7.9 7.9 0 1 1-7.9 7.9 7.89 7.89 0 0 1 7.9-7.9ZM75.8 7.62a7.35 7.35 0 1 0 7.35 7.35 7.35 7.35 0 0 0-7.35-7.35Zm0 2.5a4.85 4.85 0 1 1-4.8 4.85 4.85 4.85 0 0 1 4.8-4.85ZM20.17 0a12.68 12.68 0 1 0 12.68 12.68A12.68 12.68 0 0 0 20.17 0Zm0 2.5A10.18 10.18 0 1 1 10 12.68 10.18 10.18 0 0 1 20.17 2.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M46.57 57.27v21.82h-2.5V57.27h2.5zM32.77 47.82l1.47 2.02-14.1 10.34-1.47-2.02 14.1-10.34zM57.81 49.46l12.86 8.3-1.36 2.1-12.86-8.3 1.36-2.1zM69.8 17.52l1.66 1.87-15.19 13.5-1.66-1.87 15.19-13.5zM29.48 20.23l8.33 9.2-1.86 1.67-8.32-9.2 1.85-1.67z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M45.32 27.44a15 15 0 1 0 15 15 15 15 0 0 0-15-15Zm0 2.5a12.47 12.47 0 1 1-12.47 12.47 12.47 12.47 0 0 1 12.47-12.47Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'FiveConnectedNodesIcon';

export default Icon;
